import React from "react";
// Same import the customer-side DeleteUserModal uses. manage_users.css is a
// bundled stylesheet, not one of the globally linked /css/* files, so it has to
// be pulled in explicitly or .popup-overlay / .active-popup-box resolve to
// nothing when this page is loaded as its own chunk.
import "../../../pages/Dashboard/manage_users.css";

type Props = {
  isOpen: boolean;
  platformName?: string;
  portalLabel: string;
  isDisconnecting?: boolean;
  onClose: () => void;
  onConfirm: () => void;
};

// Matches the customer-side "Deactivate User" popup in ManageUsers, not the
// admin panel's confirm dialog: same .active-popup-box shell, same header
// close icon, same Cancel / confirm button pair.
const HubspotDisconnectModal: React.FC<Props> = ({
  isOpen,
  platformName = "HubSpot",
  portalLabel,
  isDisconnecting,
  onClose,
  onConfirm,
}) => {
  if (!isOpen) return null;

  return (
    <div className="popup-overlay" onClick={onClose}>
      <div className="active-popup-box" onClick={(e) => e.stopPropagation()}>
        <div className="d-flex flex-row justify-content-end">
          <div>
            <img
              src="/images/cancel.png"
              alt="close"
              style={{ cursor: "pointer" }}
              onClick={onClose}
              width="30"
            />
          </div>
        </div>

        <div>
          <p className="deactivate-info">Disconnect {platformName}</p>
        </div>

        <div className="mt-3">
          <p className="permanently-f">
            <em>{portalLabel}</em> will stop syncing. Results already written to your contacts stay
            where they are. You can reconnect anytime.
          </p>
        </div>

        <div className="d-flex flex-row justify-content-between mt-1">
          <button
            type="button"
            className="deactivate-cancel-bttn"
            onClick={onClose}
            disabled={isDisconnecting}
          >
            Cancel
          </button>

          <button
            type="button"
            className="saved-delete"
            disabled={isDisconnecting}
            onClick={onConfirm}
          >
            {isDisconnecting ? "Disconnecting..." : "Confirm Disconnect"}
          </button>
        </div>
      </div>
    </div>
  );
};

export default HubspotDisconnectModal;
